var _style, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "111.41px",
    height: "146.88px",
    viewBox: "0 0 111.41 146.88",
    style: {
      enableBackground: "new 0 0 111.41 146.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0C958F;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:0.8;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#3376B7;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#F0D784;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#F63137;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:#F63137;stroke:#F63137;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#F63137;stroke-width:9;stroke-miterlimit:10;}\r\n\t.st12{fill:#F63137;stroke:#FFFFFF;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#0C958F;stroke-width:13;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#3376B7;stroke-width:13;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.05,35.51c-20.25,2.03-40.66,2.53-60.99,1.47C12.03,53.11,12,69.24,11.97,85.37 c22.69-0.26,45.38-0.53,68.07-0.79c-0.13-13.7-0.26-27.4-0.4-41.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M46.15,46.44c0,4.17,0,8.34,0,12.52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M58.7,60.36c-3.89,0-7.78,0-11.67,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.99,60.36c-3.89,0-7.78,0-11.67,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M46.15,74.44c0-4.17,0-8.34,0-12.52"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 46.15,
    cy: 60.36,
    rx: 2.92,
    ry: 3.13
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 46.15,
    cy: 60.3,
    rx: 6.42,
    ry: 6.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.4742fda12b708fd4f141d52eae365bf7.svg";
export { ForwardRef as ReactComponent };